export default __webpack_public_path__ + "2008cd9ac1f593cbbe4370e89224e7e9.svg";